import { Unauthorized } from 'layouts/index'
import { useState, useRef, useEffect } from 'react'
import { LoginContainer } from 'styles/index'
import { Form } from '@unform/web'
import { logo } from 'assets/Icons'
import { DefaultButton, Input, Loading } from 'components/index'
import * as Yup from 'yup'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useFetch from 'hooks/useFetch'

interface IProps {
  isNew?: boolean
}

const schemaNewPassword = Yup.object().shape({
  password: Yup.string().required(),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Senhas devem combinar'
  ),
})

export default function CreatePassword(props: IProps) {
  const { isNew } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [password, setPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  const navigate = useNavigate()
  const formRef = useRef<HTMLFormElement | any>(null)
  const [searchParams, _] = useSearchParams()
  const [token] = useState<string>(searchParams.get('token') || '')
  // const [passError, setPassError] = useState<any>(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const api = useFetch()

  const handleCreatePassword = async (data: {
    password: string
    confirmPassword: string
    token: string | null
  }) => {
    formRef.current.setErrors({})

    setButtonLoading(true)
    if (password !== confirmPassword) {
      setButtonLoading(false)
      return formRef.current.setErrors({ password: 'Senhas devem combinar' })
    }

    try {
      const response = await api.fetch('put', data, '/gestor/password')
      if (response.fail) {
        setButtonLoading(false)
        return formRef.current.setErrors({ password: response.errors.message })
      }
      setButtonLoading(false)
      setLoading(true)
      setLoading(false)
      navigate('/login', { replace: true })
    } catch (err: any) {
      setLoading(false)
      formRef.current.setErrors({ password: err.message })
      console.log('err', err)
    }
  }

  useEffect(() => {
    // setToken(url.search.split('token=')[1])
    const validateInputs = async () => {
      try {
        await schemaNewPassword.validate(
          { password, confirmPassword },
          { abortEarly: false }
        )
      } catch (err) {
        console.log(err)
      }
    }
    validateInputs()
  }, [password, confirmPassword])

  if (loading) return <Loading />
  return (
    <Unauthorized>
      <LoginContainer>
        <img className="login-company-logo" src={logo} alt="company Logo" />
        <span className="login-title">
          {isNew ? 'Crie uma nova senha' : 'Crie senha para acesso'}
        </span>
        <span className="login-subtitle">
          Ela deve ter apenas números e, no mínimo, 8 dígitos.
        </span>
        <Form
          onSubmit={() => console.log('submit')}
          className="login-form"
          autoComplete="off"
          ref={formRef}
        >
          <div className="input-container">
            <Input
              onChange={(e: any) => setPassword(e.target.value)}
              name="Fpassword"
              type="password"
              placeholder={isNew ? 'Criar nova senha' : 'Criar senha'}
              value={password}
            />
            <Input
              onChange={(e: any) => setConfirmPassword(e.target.value)}
              name="confirmPassword"
              type="password"
              placeholder={isNew ? 'Confirmar nova senha' : 'Confirmar senha'}
              value={confirmPassword}
              // error={passError}
            />
          </div>
          <DefaultButton
            style={{ marginTop: 10 }}
            $loading={buttonLoading}
            orange
            onClick={() =>
              handleCreatePassword({
                password,
                confirmPassword,
                token,
              })
            }
          >
            Criar senha
          </DefaultButton>
        </Form>
      </LoginContainer>
    </Unauthorized>
  )
}
